module.exports = __webpack_public_path__ + "static/media/mw17.34d16e19.webp";